import styled from 'styled-components'

export const ModulesContainer = styled.div`
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  gap: 26px;
`
export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  width: 335px;
  height: 133px;
  cursor: pointer;
  overflow: hidden;
`

export const CardIconSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 137px;
  width: 108px;
  background: #81acc4;
  border-radius: 16px 0px 0px 16px;
  padding: 0;
`

export const CardDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  margin: 10px 0 0 16px;
`

export const CardTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #1f2124;
`

export const Icon = styled.img`
  /* height: 100%;
  width: 100%; */
  object-fit: contain;
  padding: 0;
`

export const UploadSizeRecomended = styled.p`
  width: 174px;
  color: #797a7c;
  font-weight: 100;
  font-size: 16px;
`
